import moment from 'moment-timezone';

export type TVEyesIFrameWindowMessageAction = 'setPlayhead' | 'setStartPoint' | 'setEndPoint' | 'pause';
interface Properties {
    dateTime: string;
}

export class TVEyesIFrameWindowMessage {
    private action: TVEyesIFrameWindowMessageAction;
    private properties: Properties;

    constructor(action: TVEyesIFrameWindowMessageAction, datetime: string) {
        this.action = action;
        const dateTime = moment.utc(datetime).format('MM/DD/YYYY HH:mm:ss');
        this.properties = {
            dateTime: dateTime
        };
    }

    toJSON(): string {
        return JSON.stringify({
            action: this.action,
            properties: this.properties
        });
    }
}
